module.exports = __webpack_public_path__ + "static/img/DOUBLE COATING PU products discription1_deskstop.a3fde6c9.jpg";